import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import { VideoDetailInterface } from "@/components/VideoPage/api/interface";
import { VideoState } from "@/components/VideoPage/redux/types";

const selectVideo = (state: RootState): VideoState => state?.video;

export default createDraftSafeSelector(selectVideo, (video: VideoState): VideoDetailInterface => video.videoData);
